import * as controls_index from './controls/index';
import String from './utils/String';

/**
 * Class Controls
 */
export default class Controls {
  static register(block, control) {
    // Empty
    if (!control) return;

    // Array loop
    if (Array.isArray(control)) {
      if (control.length == 0) return;

      control.forEach(item => {
        Controls.register(block, item);
        return;
      });
    }

    // 
    let name,
      options = {};

    if (typeof control == 'string') {
      name = control;
    } else if (typeof control == 'object') {
      name = control.name;

      delete control.name;
      options = control;
    }

    if (!name) return;

    Controls.instantiate(name, block, options);
  }

  static instantiate(control, block, options) {
    const control_name = String.pascalCase(control);

    if (!controls_index[control_name]) return;

    new controls_index[control_name](block, options);
  }
}
